import { Display } from "../../tiles";
export class CanvasDisplay extends Display {
    static CreateCanvas(width, height) {
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    static ResizeToDisplaySize(canvas, scale = 1) {
        const displayWidth = canvas.clientWidth;
        const displayHeight = canvas.clientHeight;
        const ratio = window.devicePixelRatio;
        const w = displayWidth * ratio * scale;
        const h = displayHeight * ratio * scale;
        if (canvas.width != w || canvas.height != h) {
            canvas.width = w;
            canvas.height = h;
            return true;
        }
        return false;
    }
    constructor(canvas, scale, resizeToFitClient) {
        const f = resizeToFitClient == undefined || resizeToFitClient == true;
        scale = scale ?? 1.0;
        if (f) {
            CanvasDisplay.ResizeToDisplaySize(canvas, scale);
        }
        super(canvas);
        this.canvas = canvas;
        this._resizeToFitClient = f;
        this._scale = scale;
        const canvasAsElement = canvas;
        this._resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                if (entry.target === canvasAsElement) {
                    if (this._resizeToFitClient) {
                        CanvasDisplay.ResizeToDisplaySize(canvas, this._scale);
                    }
                    this.resize(canvas.width, canvas.height);
                }
            }
        });
        this._resizeObserver.observe(canvasAsElement);
    }
    getContext(options) {
        return this.canvas.getContext("2d", options);
    }
    dispose() {
        super.dispose();
        this._resizeObserver.disconnect();
    }
}
//# sourceMappingURL=map.canvas.display.js.map